import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UserServiceImpl } from 'src/app/user/service/user.service';
import { filter, take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { Profile } from 'src/app/user/user.model';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';
import { languageSelector, organisationSelector } from 'src/app/global/store/global.selectors';
import { userRecordSelector } from 'src/app/user/store/user.selectors';
import { UserParkingConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

@Component({
    selector: 'app-user-parking',
    templateUrl: './user-parking.component.html',
    styleUrls: ['./user-parking.component.scss'],
})
export class UserParkingComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject();

    nowLoading: boolean;

    history: any[] = [];

    prepaid: any;

    addedAmount: number | undefined;

    name: string | undefined;

    constructor(
        public dialog: MatDialog,
        public store: Store<State>,
        private translate: TranslateService,
        private userService: UserServiceImpl,
    ) {}

    ngOnInit(): void {
        this.nowLoading = true;

        this.store
            .select(languageSelector)
            .pipe(
                takeUntil(this.destroy$),
                tap((lang) => {
                    this.translate.use(lang);
                }),
            )
            .subscribe();
        this.store
            .select(organisationSelector)
            .pipe(
                takeUntil(this.destroy$),
                filter((profile) => !!profile),
                tap((profile) => {
                    this.userService.organisation = profile.tag;
                }),
            )
            .subscribe();

        this.store
            .select(userRecordSelector)
            .pipe(
                takeUntil(this.destroy$),
                filter((profile) => !!profile),
                tap((profile) => {
                    this.userService.user = profile.id;
                    this.name = `${profile.firstName} ${profile.lastName}`;
                }),
                tap(() => {
                    this.getHistory();
                    this.nowLoading = false;
                }),
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    addParking() {
        if (this.addedAmount === undefined || this.addedAmount <= 0 || this.addedAmount === null) {
            return;
        }
        const amount = this.addedAmount.toFixed(2);
        const ref = this.dialog.open(UserParkingConfirmModalComponent, {
            data: {
                money: amount,
                user: this.name,
            },
        });
        ref.afterClosed().subscribe((result) => {
            if (result.event === 'OK') {
                this.userService
                    .addParking(amount)
                    .pipe(
                        take(1),
                        takeUntil(this.destroy$),
                        tap(() => {
                            this.getHistory();
                            this.addedAmount = 0;
                        }),
                    )
                    .subscribe();
            }
        });
    }

    getHistory() {
        this.userService
            .getHistory()
            .pipe(
                take(1),
                takeUntil(this.destroy$),
                tap((history: any) => {
                    this.history = history.history;
                    this.prepaid = `${history.prepaid}$`;
                }),
            )
            .subscribe();
    }
}
